import React, { Component } from 'react'
import './Spinner.css'

let Spinner = () => <div className="loader spinner"></div>

export default Spinner
